//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    datasheetFile: Object,
    leftAlign: {
      type: Boolean,
      default: false
    },
    noSpacer: {
      type: Boolean,
      default: false
    }
  }
}
